import classNames from 'classnames'
import { appGetState } from 'legacy/lut/store'
import { lookupGetStateOld } from 'legacy/lut/store'
import { FC } from 'react'

import { stylesTable } from 'core-components/library/list'
import { Tooltip } from 'core-components/library/tooltip'

import { ContactStatusIcon } from '../contactStatusIcon/ContactStatusIcon'

import { getPhoneCell } from './helpers/getPhoneCell'
import { IContactDataCellProps } from './models'

import styles from './ContactDataCell.module.scss'

export const ContactDataCell: FC<IContactDataCellProps> = ({ cellAttrs, column, contact }) => {
  const countries = lookupGetStateOld().references.countries
  switch (column.field) {
    case 'MobilePhone':
    case 'WorkPhone':
      const phoneCell = getPhoneCell({ contact, cellAttrs, phoneType: column.field })
      if (phoneCell) {
        return phoneCell
      }
      break
    case 'ContactID':
      return (
        <td {...cellAttrs} className={stylesTable.cell}>
          <ContactStatusIcon contact={contact} />
          {contact.get('ContactID')}
        </td>
      )
    case 'CountryOfBusiness':
      if (countries) {
        const countryCode = contact.get('CountryOfBusiness')
        const cData = countries.find((el) => el.value === countryCode)
        return (
          <td {...cellAttrs} className={stylesTable.cell}>
            {cData ? cData.name : countryCode}
          </td>
        )
      }
      break
  }

  return (
    <td {...cellAttrs} className={stylesTable.cell}>
      {contact.get(column.field)}
    </td>
  )
}
